'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function removeSpaces() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return typeof input === 'string' ? input.replace(/\s/g, '') : '';
}

exports.default = removeSpaces;
//# sourceMappingURL=removeSpaces.js.map
